import { render, staticRenderFns } from "./AgendaContainer.vue?vue&type=template&id=30774cae&"
import script from "./AgendaContainer.vue?vue&type=script&lang=js&"
export * from "./AgendaContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30774cae')) {
      api.createRecord('30774cae', component.options)
    } else {
      api.reload('30774cae', component.options)
    }
    module.hot.accept("./AgendaContainer.vue?vue&type=template&id=30774cae&", function () {
      api.rerender('30774cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/AgendaContainer.vue"
export default component.exports